import { create } from "zustand";

interface InviteDialogState {
	isOpen: boolean;
	inviteCode: string;
	poolName: string;
	openInviteDialog: (inviteCode: string, poolName: string) => void;
	closeInviteDialog: () => void;
}

export const useInviteDialogStore = create<InviteDialogState>((set) => ({
	isOpen: false,
	inviteCode: "",
	poolName: "",
	openInviteDialog: (inviteCode: string, poolName: string) => set({ isOpen: true, inviteCode, poolName }),
	closeInviteDialog: () => set({ isOpen: false, inviteCode: "", poolName: "" }),
}));
